import { OfflinePrefetchProps } from "../interface";
import {
  usePrefetchUtils,
  executePaginatedPrefetch,
} from "../utils/usePrefetchUtils";
import { useLazyFluidIntakeHistoryQuery } from "../../../api/staticFormsApi";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { storeFluidIntake } from "../../../../store/slices/fluidIntake";
import { format, subDays } from "date-fns";
import { store } from "app/services/store";
import { BASE_DAYS } from "./constants";

const HISTORY_DATE_FROM_DAYS = BASE_DAYS;

export function usePrefetchFluidIntake({ enabled }: OfflinePrefetchProps) {
  const [trigger] = useLazyFluidIntakeHistoryQuery();
  const dispatch = useDispatch();

  const handlePrefetch = useCallback(async () => {
    const dateFrom = format(
      subDays(new Date(), HISTORY_DATE_FROM_DAYS),
      "yyyy-MM-dd",
    );

    await executePaginatedPrefetch({
      name: "FluidIntake",
      trigger,
      buildQueryArgs: (page) => ({
        filter: {
          recorded_at_from: dateFrom,
        },
        limit: 100,
        page,
      }),
      storeData: (data) => dispatch(storeFluidIntake(data)),
      getLastPage: (data) => data?.meta?.last_page ?? 1,
      enableSmartCache: true,
      getFirstRecordId: (data) => data?.data?.[0]?.id ?? null,
      dispatch,
      getState: () => store.getState(),
    });
  }, [trigger, dispatch]);

  usePrefetchUtils({
    enabled,
    prefetchHandler: handlePrefetch,
  });
}
